<template>
  <div>
    <b-navbar v-if="!isLoggedIn" style="margin-left: 0px !important;" type="dark" variant="dark" fixed="top">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand >WITORA</b-navbar-brand>
    </b-navbar>
    <b-container>
      <b-row>
        <div class="Absolute-Center is-Responsive">
          <b-alert
            variant="danger"
            dismissible
            :show="showDismissibleAlert"
            @dismissed="showDismissibleAlert=false"
          >
            Доступ запрещён
          </b-alert>
          <div class="col-sm-12 col-md-10 col-md-offset-1">
            <b-form id="loginForm"  @submit.stop.prevent="login()">
              <b-form-group
                id="usernameGroup"
                :label="$t('message.login.login')"
                label-for="usernameInput"
              >
                <b-form-input
                  id="usernameInput"
                  type="text"
                  :placeholder="$t('message.login.enterLogin')"
                  v-model="username"/>
              </b-form-group>

              <b-form-group
                id="passwordGroup"
                :label="$t('message.login.password')"
                label-for="passwordInput"
              >
                <b-form-input
                  id="passwordInput"
                  type="password"
                  :placeholder="$t('message.login.enterPassword')"
                  v-model="password"/>
              </b-form-group>
              <b-form-group>
                <b-button type="submit" variant="dark" block >{{ $t("message.login.signIn") }}</b-button>
              </b-form-group>
            </b-form>
          </div>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>

export default {
  name: 'Login',
  data () {
    return {
      username: "",
      password: "",
      showDismissibleAlert: false
    }
  },
  methods: {
    login() {
      this.post("login", {
        username: this.username,
        password: this.password
      },function(result){
        if (result.status === 200) {
          this.$store.dispatch("login", {
            token: result.body.token
          }).then(res => {
            this.userInfo(result.body.token);
          })
        }

        if (result.status === 401) {
          this.showDismissibleAlert = true;
        }

      }.bind(this));
    },
    post: function (url, data, callback) {
      return this.$http.post(url,data,null).then(result => {
        callback(result);
      },error =>{
        callback(error);
      });
    },
    userInfo(token) {
      this.$http.get("users/info").then(result => {
        if (result.status === 200) {
          this.$store.dispatch("login", {
            token: token,
            role: result.body.role,
            permissions: result.body.permissions,
          }).then(res => {
            if (result.body.role === "accountant"){
              return
            }
            if (result.body.role === "marketer"){
              this.$router.push({name:"ManagerStatistics"}).catch(()=>{});
              return
            }
            this.$router.push('/').catch(()=>{});
          })
        }
      },error => {
        console.log(error);
        if (error.status === 401) {
          this.showDismissibleAlert = true;
        }
        if (error.status === 403) {
          this.showDismissibleAlert = true;
        }
      });
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  }
}
</script>

<style scoped>
.Absolute-Center {
  margin: auto;
  position: absolute;
  top: 0; left: 0; bottom: 0; right: 0;
}

.Absolute-Center.is-Responsive {
  width: 50%;
  height: 50%;
  min-width: 400px;
  max-width: 500px;
  padding: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Authorization/Login.vue